import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import MapPropTypes from '../../MapPropTypes';
import strings from '../../../strings';
import utils from '../../../utils';
import './Summary.scss';
import { Scrollbars } from 'react-custom-scrollbars';

class Summary extends Component {
    static propTypes = {
        cartTotal: PropTypes.number.isRequired,
        offer: MapPropTypes.OfferProps.isRequired,
        cart: MapPropTypes.CartProps,
        onUpdateInstructions: PropTypes.func.isRequired,
        removeItemFromCart: PropTypes.func.isRequired,
        updateSaveForLater: PropTypes.func.isRequired,
        onEditOrder: PropTypes.func.isRequired,
        excelUpload: PropTypes.bool,
        sheetResponseData: PropTypes.object,
        soldTo: PropTypes.string,
    };

    _handleSaveForLaterClick(itemId, flag) {
        this.props.updateSaveForLater(itemId, flag); // Dispatch action to update save for later state
    }

    _showDays() {
        if (this.props.offer.dailyPricingEnabled) {
            return true;
        } else {
            return false;
        }
    }

    _renderSummary() {
        if (!this.props.excelUpload) {
            return (
                <dl>
                    <div className='cart-summary'>
                        <div className="credits-used ">
                            <h2>{strings.creditsUsed}</h2>
                            <p className="credits-value"> {utils.formatPrice(this.props.cartTotal)}</p>
                        </div>
                        <div className="available-credits">
                            <p>{strings.availableCredits}</p>
                            <p className="credits-amount">{utils.formatPrice(this.props.offer.balance)}</p>
                        </div>
                        <div className="remaining-credits">
                            <p>Remaining</p>
                            <p className="remaining-credits-amount">{utils.formatPrice(this.props.offer.balance - this.props.cartTotal)}</p>
                        </div>
                    </div>
                </dl>
            );
        }
    }

    _renderPurchases(cart, isSavedLaterFlag) {
        return (
            <div className="cart-table">
                <Scrollbars style={{ width: '100%', height: 160 }} universal={true}>
                    <table>
                        <thead>
                            <tr>
                                <th>{strings.partNumber}</th>
                                <th>{strings.product}</th>
                                <th>Server Information</th>
                                <th>{strings.seats}</th>
                                <th>Start Date</th>
                                <th>End Date</th>
                                {this._showDays() ? <th>{strings.days}</th> : <th>{strings.months}</th>}
                                {this.props.offer.weeklyPricingEnabled && <th>{strings.weeks}</th>}
                                <th>{strings.subtotal}</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {cart.filter((item) => item.addedToCart).map((item, i) => {
                                // Compare saveForLater with isSavedLaterFlag
                                if (item.saveForLater === isSavedLaterFlag) {
                                    return (
                                        <tr key={i}>
                                            <td>{item.pricing.product.mentorId}</td>
                                            <td>{item.pricing.product.name}</td>
                                            <td>{item.server.mentorId}</td>
                                            <td>{item.seats}</td>
                                            <td className="text-nowrap">
                                                {moment(item.startDate).format('MM-DD-YYYY')}
                                            </td>
                                            <td className="text-nowrap">
                                                {moment(item.endDate).format('MM-DD-YYYY')}
                                            </td>
                                            {this._showDays() ? <td>{item.dayCount}</td> : <td>{item.monthCount}</td>}
                                            {this.props.offer.weeklyPricingEnabled && <td>{item.weekCount}</td>}
                                            <td>{utils.formatPrice(item.subtotal)}</td>
                                            <td>
                                                <span className="cart-actions">
                                                    {item.saveForLater ? (
                                                        <button
                                                            type="button"
                                                            className="move-to-cart-button"
                                                            onClick={() => this._handleSaveForLaterClick(i, false)}
                                                        >
                                                            <span className='btn-link text-link'>Move to Cart</span>
                                                        </button>
                                                    ) : (
                                                        <button
                                                            type="button"
                                                            className="save-for-later-button"
                                                            onClick={() => this._handleSaveForLaterClick(i, true)}
                                                        >
                                                            <span className='btn-link text-link'>Save for Later</span>
                                                        </button>
                                                    )}
                                                    <div className="cart-remove">
                                                        <button
                                                            type="button"
                                                            className="close cart-remove-icon"
                                                            aria-label={strings.remove}
                                                            onClick={() => this.props.removeItemFromCart(i, item.cartId, false)}>
                                                            <span className="text-danger remove-text" >
                                                                {strings.remove}
                                                            </span>
                                                            <svg className="remove-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                                <circle cx="12" cy="12" r="12" fill="red" />
                                                                <line x1="8" y1="8" x2="16" y2="16" stroke="white" strokeWidth="2" />
                                                                <line x1="16" y1="8" x2="8" y2="16" stroke="white" strokeWidth="2" />
                                                            </svg>
                                                        </button>
                                                    </div>
                                                    <div></div>
                                                </span>
                                            </td>
                                        </tr>
                                    );
                                }
                                return null; // Return null if item doesn't match the condition
                            })}
                        </tbody>
                    </table>
                </Scrollbars>
            </div>
        );
    }

    render() {
        const cartItems = this.props.cart; // Use the same cart for both
        const nonSavedItemsCount = cartItems.filter((item) => item.addedToCart && !item.saveForLater).length;
        const savedForLaterItemsCount = cartItems.filter((item) => item.addedToCart && item.saveForLater).length;

        return (
            <div>
                {this._renderSummary()}

                <div >
                    {/* Conditionally render the main cart items table */}
                    {nonSavedItemsCount > 0 && (
                        <div className="cart-section">
                            <div className="section-header">
                                <h2>{strings.yourCart}</h2>
                                <div className='pull-right'>
                                    <button
                                        type="button"
                                        className="btn btn-link manage-cart "
                                        onClick={this.props.onEditOrder} // Assuming an onEditOrder callback is passed as a prop
                                    >
                                        <span className="edit-icon">
                                            <svg className="icon icon-plm-edit">
                                                <use href="#icon-plm-edit" />
                                            </svg>
                                        </span>
                                        Edit/Manage Cart
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-link clear-cart"
                                        onClick={() => this.props.removeItemFromCart(-1, '', false)}
                                    >
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M13 2C14.5977 2 15.9037 3.24892 15.9949 4.82373L16 5H21V7H19.453L18.2731 18.4116C18.0692 20.3825 16.457 21.8962 14.4982 21.9949L14.2943 22H9.70566C7.72421 22 6.05272 20.5521 5.75297 18.6138L5.7269 18.4116L4.546 7H3V5H8C8 3.40232 9.24892 2.09634 10.8237 2.00509L11 2H13ZM17.443 7H6.556L7.71628 18.2058C7.81619 19.1716 8.59244 19.9178 9.5453 19.9936L9.70566 20H14.2943C15.2143 20 16.0036 19.2901 16.1933 18.394L16.2837 18.2058L17.443 7ZM10 9V17H8V9H10ZM16 9V17H14V9H16Z" />
                                        </svg>
                                        <span className='clear-text'>Clear Cart</span>
                                    </button>
                                </div>
                            </div>
                            {this._renderPurchases(cartItems, false)} {/* Items to purchase */}
                        </div>
                    )}

                    {/* Conditionally render the "Save For Later" section */}
                    {savedForLaterItemsCount > 0 && (
                        <div className="cart-section">
                            <div className="section-header">
                                <h2>Saved For Later</h2>
                                <div className='pull-right'>
                                    <button
                                        type="button"
                                        className="btn btn-link clear-cart"
                                        onClick={() => this.props.removeItemFromCart(-1, '', true)}
                                    >
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M13 2C14.5977 2 15.9037 3.24892 15.9949 4.82373L16 5H21V7H19.453L18.2731 18.4116C18.0692 20.3825 16.457 21.8962 14.4982 21.9949L14.2943 22H9.70566C7.72421 22 6.05272 20.5521 5.75297 18.6138L5.7269 18.4116L4.546 7H3V5H8C8 3.40232 9.24892 2.09634 10.8237 2.00509L11 2H13ZM17.443 7H6.556L7.71628 18.2058C7.81619 19.1716 8.59244 19.9178 9.5453 19.9936L9.70566 20H14.2943C15.2143 20 16.0036 19.2901 16.1933 18.394L16.2837 18.2058L17.443 7ZM10 9V17H8V9H10ZM16 9V17H14V9H16Z" />
                                        </svg>
                                        <span className='clear-text'>Clear Saved for Later</span>
                                    </button>
                                </div>
                            </div>
                            {this._renderPurchases(cartItems, true)} {/* Items saved for later */}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default Summary;



// WEBPACK FOOTER //
// ./app/components/Modals/ShoppingCartModal/Summary.jsx